import axios from "axios";
import * as Services from "../../../Service/Service";
import * as config from "../../config";
import * as Url from "../../../Service/Url";

export const checkReportDataForSDOH = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.CHECK_REPORT_DATA_FOR_SDOH + id, token);
  return res;
};

export const DownloadReports = async (payload, UserId) => {
  const token = localStorage.getItem("token");
  const {
    largeClaimPrognosisReport,
    largeClaimAnalysisReport,
    largeClaimDetail,
    sdohExtractDetail,
    renewalAnalysis,
    experienceAnalysis,
    asoAnalysis,
    allAbove,
    censusDetail,
    chronicRisk,
    biometricsOutput,
    gdorReportOutput,
    clientID,
    client_Name,
  } = payload;
  let url = `/api/Reports/DownloadReports?LargeClaimPrognosisReport=${largeClaimPrognosisReport}&LargeClaimAnalysisReport=${largeClaimAnalysisReport}&LargeClaimDetail=${largeClaimDetail}
  &SDOHExtractDetail=${sdohExtractDetail}&RenewalAnalysis=${renewalAnalysis}&ExperienceAnalysis=${experienceAnalysis}&AsoAnalysis=${asoAnalysis}&AllAbove=${allAbove}
  &CensusDetail=${censusDetail}&ChronicRisk=${chronicRisk}&BiometricsOutput=${biometricsOutput}&GDORReportOutput=${gdorReportOutput}&ClientID=${clientID}&
  Client_Name=${client_Name}&UserId=${UserId}`;
  const responseType = "blob";

  let res = Services.GETSERVICE(
    `${url}`,
      {},
     {responseType}
  );
  return res;
};

export const CheckReportsData = async (payload, UserId) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.CHECK_REPORTS_DATA + `UserId=${UserId}`,
    payload,
    token
  );
  return res;
};

// export const ImportDataintoSnowflake = async (value, UserId, payload) => {
//   const token = localStorage.getItem("token");
//   console.log(payload);
//   let res = await Services.POST(
//     Url.IMPORTDATAINTOSNOWFLAKE + `IsAppendorReplace=${value}&UserId=${UserId}`,
//     payload,
//     token
//   );
//   return res;
// };

export const ImportDataintoSnowflakewithTracking = async (
  value,
  UserId,
  payload
) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(
    Url.IMPORTDATAINTOSNOWFLAKEWITHTRACKING +
      `IsAppendorReplace=${value}&UserId=${UserId}`,
    payload,
    token
  );
  return res;
};

export const CheckDatainsertintoSnowflake = async (value) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.CHECKDATAINSERTINTOSNOWFLAKE + `TrackingId=${value}`,
    token
  );
  return res;
};
